// import { initSentry } from '#libs'
import { setContentMinHeight } from '#libs/utils'

import './theme.css'

// TODO: Uncomment this when we need integrate Sentry
// initSentry()

document.addEventListener('DOMContentLoaded', () => {
  setContentMinHeight()

  window.addEventListener('resize', () => {
    setContentMinHeight()
  })
})
